import {
  Box, Card, Flex, Text,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import LineChart from '../../Core/Charts/LineChart';
import { useGetFormStatsQuery } from '../../Services/apiSlice';

dayjs.extend(isToday);

const emptyChart = [
  {
    name: 'Submissions',
    data: [
      { x: dayjs().subtract(3, 'month').format('YYYY-MM-DD'), y: 0 },
      { x: dayjs().format('YYYY-MM-DD'), y: 0 }],
  },
  { name: 'Views', data: [] },
];

const FormSubmitionsChart = () => {
  const { data, isFetching, error } = useGetFormStatsQuery();

  const submissionsData = (isFetching || error) ? [] : Object.entries(data.stats.sub)
    .map(([x, y]) => ({ x, y }))
    .sort((a, b) => Date.parse(a.x) - Date.parse(b.x));

  const viewsData = (isFetching || error) ? [] : Object.entries(data.stats.views)
    .map(([x, y]) => ({ x: dayjs(x).format('YYYY-MM-DD'), y }))
    .sort((a, b) => Date.parse(a.x) - Date.parse(b.x));

  const [last] = submissionsData.slice(-1);
  const [lastView] = viewsData.slice(-1);
  if (!(isFetching || error) && last && lastView) {
    if (dayjs(last.x).isBefore(lastView.x, 'day')) {
      submissionsData.push({ x: dayjs(lastView.x).format('YYYY-MM-DD'), y: 0 });
    } else if (dayjs(last.x).isAfter(lastView.x, 'day')) {
      viewsData.push({ x: dayjs(last.x).format('YYYY-MM-DD'), y: last.y });
    }
  }

  let thisMonth = 0;
  let prevMonth = 0;
  submissionsData.forEach((i) => {
    if (dayjs().isSame(i.x, 'month')) {
      thisMonth += i.y;
    } else {
      const prev = dayjs().subtract(1, 'month');
      if (prev.isSame(i.x, 'month')) {
        prevMonth += i.y;
      }
    }
  });

  const diff = thisMonth - prevMonth;

  return (
    <Card
      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
      p="0px"
      maxW={{ sm: '320px', md: '100%' }}
    >
      <Flex direction="column" mb="6" p="28px 0px 0px 22px">
        <Text color="#fff" fontSize="lg" fontWeight="bold" mb="6px">
          Form submissions
        </Text>
        {!(isFetching || error) && (
          submissionsData.length === 0 ? <Text color="#fff" fontSize="sm">There are no submissions yet</Text> : (
            <Text color="#fff" fontSize="sm">
              <Text as="span" color={diff >= 0 ? 'green.400' : 'red.400'} fontWeight="bold">
                {diff === 0 && ('same as')}
                {diff > 0 && (`+${diff} more`) }
                {diff < 0 && (`${-diff} less`)}
                {' '}
              </Text>
              than previous month
            </Text>
          )
        )}
      </Flex>
      <Box minH="300px">
        {!(isFetching || error) && (
          <LineChart
            chartData={submissionsData.length === 0 && viewsData.length === 0 ? emptyChart : [
              { name: 'Submissions', data: submissionsData },
              { name: 'Views', data: viewsData },
            ]}
          />
        )}
      </Box>
    </Card>

  );
};
export default FormSubmitionsChart;
